export default __webpack_public_path__ + "static/media/referenceIcon.3e38fca8.svg";